import { RouteObject } from "react-router-dom";

import { lazyWithReload } from "@/utils/lazyWithReload";

const NotFound = lazyWithReload(() => import("@/pages/Error/404"));

export const notFound: RouteObject[] = [
  {
    path: "*",
    element: <NotFound />,
  },
];
